import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Scenario } from '../types/scenario'

interface ScenarioState {
  byId: Record<string, Scenario>
}

const initialState: ScenarioState = {
  byId: {},
}

const scenarioSlice = createSlice({
  name: 'scenario',
  initialState,
  reducers: {
    setScenario: (state, action: PayloadAction<Scenario>) => {
      state.byId[action.payload.id] = action.payload
    },
    removeScenario: (state, action: PayloadAction<string>) => {
      delete state.byId[action.payload]
    },
  },
})

export const { setScenario, removeScenario } = scenarioSlice.actions

export default scenarioSlice.reducer
